export type SiteConfig = typeof siteConfig;

export const siteConfig = {
	name: "Minecraft Community Awards",
	description:
		"Premios otorgados desde la comunidad de Minecraft para la comunidad de Minecraft.",
	navItems: [
		{
			label: "Inicio",
			href: "/",
		},
		{
			label: "Categorías",
			href: "/categories",
		},
	],
	navMenuItems: [
		{
			label: "Inicio",
			href: "/",
		},
		{
			label: "Categorías",
			href: "/categories",
		},
	],
	links: {
		twitter: "https://x.com/MCA_Premios",
		twitterSpreen: "https://x.com/SpreenDMC",
		kick: "https://kick.com/spreen",
		twitch: "https://www.twitch.tv/elspreen",
		vote: "/vote",
	},
};
